import classNames from 'classnames/bind';
import React from 'react';

import styles from './index.scss';

const cx = classNames.bind(styles);

const DownloadButton = ({ link }) => (
  <>
    <button
      className={`op-navigators op-clear ${cx('DownloadButton')}`}
      type="button"
    >
      <a href={link} target="_blank" download="Download" title="download" />
    </button>
  </>
);

export default DownloadButton;
